import * as React from "react";
import type { MergedTimelineEntry } from "../../../../domains/MergedTimelineEntry";
import type { paths } from "../../../../lib/api/v1";
import TimelineItem from "../TimelineItem";

// 学習記録ソースの 1 件分（student に課金情報を含む生徒タイムライン用の交差型）。
// 取得フック（useFetchTimelineStudyRecords）の data 要素と同一になるよう同じ paths 型から導出する。
type TimelineStudyRecord =
  paths["/api/v1/sections/{section_id}/timeline/study_records"]["get"]["responses"]["200"]["content"]["application/json"]["studyRecords"]["data"][number];

type Props = {
  displayed: MergedTimelineEntry<TimelineStudyRecord>[];
  currentOperator: React.ComponentProps<typeof TimelineItem>["currentOperator"];
  updateStudyRecordQueryCache: React.ComponentProps<
    typeof TimelineItem
  >["updateStudyRecordQueryCache"];
  drillProgressMap: React.ComponentProps<
    typeof TimelineItem
  >["drillProgressMap"];
  // timelineItem カード枠の className。余白などが画面ごとに異なるため、スタイルは各 feature の
  // SCSS Module に残し、ここでは className のみを注入で受け取る。
  itemClassName: string;
};

// 学習記録エントリの統合ストリーム描画。校舎リアルタイムタブ（SectionsTimelinePage）と
// 生徒個別タイムライン（StudentsTimelinePage）で共通利用する。
// AI 質問統合表示の凍結（005-freeze-ai-question-timeline）に伴い、学習記録のみを描画する。
export const MergedTimelineList = ({
  displayed,
  currentOperator,
  updateStudyRecordQueryCache,
  drillProgressMap,
  itemClassName,
}: Props) => (
  <>
    {displayed.map((entry) => (
      <div className={itemClassName} key={`study-${entry.studyRecord.id}`}>
        <TimelineItem
          currentOperator={currentOperator}
          studyRecord={entry.studyRecord}
          student={entry.studyRecord.student}
          canSendComment={entry.studyRecord.student.canSendComment}
          showHeader={true}
          sectionId={entry.studyRecord.student.section.id}
          updateStudyRecordQueryCache={updateStudyRecordQueryCache}
          drillProgressMap={drillProgressMap}
        />
      </div>
    ))}
  </>
);
